import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-24 bg-brand-cream relative" data-id="element-100">
      <div className="container mx-auto px-6" data-id="element-101">
        <div className="max-w-4xl mx-auto" data-id="element-102">
          <FadeIn data-id="element-103">
            <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-brand-pink/30 relative" data-id="element-104">
              {/* Decorative quote mark */}
              <div className="absolute -top-6 -left-4 text-8xl text-brand-gold opacity-20 font-serif leading-none" data-id="element-105">
                "
              </div>

              <p className="text-xl md:text-2xl text-brand-dark mb-8 leading-relaxed font-medium" data-id="element-106">
                Vivir en USA con un puntaje bajo es como caminar con una cadena
                atada al pie. No importa cuánto trabajes o cuánto ganes; si tu
                reporte de crédito tiene errores o deudas viejas, el sistema te
                bloquea el paso.
              </p>

              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-107">
                Sientes vergüenza en el concesionario, miedo de que el dueño del
                apartamento te pida un depósito doble y una frustración enorme
                porque las agencias de "reparación de crédito" te cobran $100 al
                mes solo por enviar un par de cartas que tú podrías hacer en 10
                minutos.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}